import { InferType, mixed, number, object, string } from "yup";

export const SchemaItemGeneric = object({
  label: string().default(""),
  value: mixed<any>().default(""),
  name: string().default(""),
  id: mixed<number | string>().default(""),
  custom: mixed<any>().nullable(),
  extraData: mixed<any>().nullable()
}).default({
  label: "",
  value: "",
  name: "",
  id: ""
});

export type IItemGenericSchema = InferType<typeof SchemaItemGeneric>;
